module.exports = __webpack_public_path__ + "static/media/Folder.41fc1ce3.svg";